import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionTitle from "@/components/base/SectionTitle";

const FILTERS = ["全部", "电影", "纪录片", "剧集", "短片"];

export default function LatestGrid() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    const filtered = active === "全部" ? movies : movies.filter((movie) => movie.type === active);
    return filtered.slice(0, 10);
  }, [active]);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="Latest Titles"
          title="最新影视内容"
          description="按类型浏览近期上线的影片资料，封面、年份与类型标签一一对应。"
          actionLabel="查看全部"
          actionTo="/category"
        />

        <div className="mb-6 flex flex-wrap gap-2">
          {FILTERS.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setActive(item)}
              className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-1.5 text-xs transition-colors ${
                active === item
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-foreground-900"
              }`}
            >
              {item}
            </button>
          ))}
          <span className="ml-auto hidden items-center gap-1 self-center text-[11px] text-foreground-400 sm:flex">
            <i className="ri-layout-grid-line" />
            共 {list.length} 部
          </span>
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center text-sm text-foreground-500">
            该类型暂无演示内容，试试其他分类。
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {list.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        )}

        <div className="mt-8 flex justify-center">
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            进入影视分类页
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}